import { __ } from '@99designs/i18n';
import { usePricingContextIfProvided } from './usePricingContextIfProvided';

const MARKETS_WITHOUT_VAT_MESSAGE = ['in', 'au', 'sg', 'nz', 'us', 'ca'];

export function useVatMessaging(): string | null {
    const pricingContext = usePricingContextIfProvided();

    const hasVatMessage =
        pricingContext?.market &&
        !MARKETS_WITHOUT_VAT_MESSAGE.includes(pricingContext.market.toLowerCase());

    if (!hasVatMessage) {
        return null;
    }

    return pricingContext?.vatInclusive
        ? __('inc. VAT', {
              _context:
                  'Short tax message displayed next to the VAT-inclusive price of a design service product.',
          })
        : __('ex. VAT', {
              _context:
                  'Short tax message displayed next to the VAT-exclusive price of a design service product.',
          });
}
